<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    first_btn="Завантажити"
    :loading="loading"
    :title="$t('Tenders.DownloadTendersToExcel')"
    @apply="downloadFile"
    @close="dialog = false">
    <template #activator-btn>
      <sButton
        data-qa="btn-export-to-excel"
        :disabled="disabled"
        icon="excel"
        :rounded="false"
        small
        type="text"
        @click="dialog = true">
        {{ $t('Tenders.DownloadTendersToExcel') }}
      </sButton>
    </template>
    <template #card-text>
      {{ $t('Suppliers.ItemForExport', {count: count, type: $tc('Suppliers.Label', count) } ) }}
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import axios from 'axios'
import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()

export default {
  name: 'downloadSuppliersToExcel',
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  props: {
    /**
     * Колличество эллементов для выгрузки
     */
    count: {
      type: Number,
    },
    /**
     * Параметры фильтра
     */
    filter: {
      type: Object
    },
    /**
     * Имя файла
     */
    title: {
      type: String,
      default: 'report'
    },
    disabled: {
      type: Boolean
    }
  },
  methods: {
    /**
     * Загрузка архива
     */
    async downloadFile() {
      this.loading = true
      const url = `${window.config.GrapgQlUrl}/files/generateReport`

      const headers = await files_api.getHeaders()
      headers['Content-Type'] = 'application/json'

      await axios.post(url,
        this.filter,
        {
          params: null,
          headers,
          responseType: 'blob'
        }
      ).then((response) => {
        let url = URL.createObjectURL(response.data)
        let a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('download', this.title)
        a.click()
      }).finally(() => {
        this.loading = false
      })
    }
  },
  components: {
    DialogTemplateToolkit,
  }
}
</script>
